import React, { useState, useEffect } from "react";
import { TitleSection } from "../../components/titleSection";
import { Table } from "../../components/table";
import { CalendarRange } from "../../components/myCalendar";
import {
    FlexboxGrid,
    Col,
    Form,
    FormGroup,
    FormControl,
    ControlLabel,
    SelectPicker,
    InputGroup,
    Icon,
    Button,
    CheckboxGroup,
    Checkbox,
} from "rsuite";
import { transactionService } from "../../services/transaction.service";
import { useSelector } from "react-redux";
import { getColumns } from "../../hooks/templateColumnsHook";
import statusJson from "../../data/status.json";
import { StatusEnum } from "../../enum/statusEnum";
import "./transactions.scss";
import { useTranslation } from "react-i18next";

export const Transactions = (props) => {
    const {t, i18n} = useTranslation();
    const userSetting = useSelector((state) => state.userSetting);
    const [status, setStatus] = useState([]);
    const [statusChargeBack, setStatusChargeBack] = useState([{ idStatusChargeBack: 0, name: '', description: '' }]);
    const [data, setData] = useState([]);
    const [isChargeBack, setIsChargeBack] = useState(false);
    const statusMoney = [0, StatusEnum.Accepted, StatusEnum.ExpiredCashPayment, StatusEnum.PendingPayment];
    const currentDate = new Date();
    const initialFilters = {
        idStatus: 0,
        initDate: currentDate,
        endDate: currentDate,
        referenceNumber: "",
        email: "",
        statusChargeBack: [],
        referenceCash: "",
        isMoney: false
    };
    const setInitialFilters = () => {
        let filtersTmp = initialFilters;
        if (sessionStorage["rp_filters"] !== undefined) {
            filtersTmp = JSON.parse(sessionStorage["rp_filters"]);
            filtersTmp.initDate = filtersTmp.initDate ? new Date(filtersTmp.initDate) : "";
            filtersTmp.endDate = filtersTmp.endDate ? new Date(filtersTmp.endDate) : "";
        }

        return filtersTmp;
    };
    const [filters, setFilters] = useState(setInitialFilters());

    const pageSize = 10;
    const readCursorStack = () => {
        try {
            const parsed = JSON.parse(sessionStorage.getItem("rp_CursorStack") || "[0]");
            if (Array.isArray(parsed) && parsed.length > 0) return parsed.map((id) => Number(id) || 0);
        } catch (e) { }
        return [0];
    };
    const [cursorStack, setCursorStack] = useState(readCursorStack);
    const [tableData, setTableData] = useState({ rows: 0, hasMore: false });

    const persistStack = (stack) => {
        setCursorStack(stack);
        sessionStorage.setItem("rp_CursorStack", JSON.stringify(stack));
    };

    useEffect(() => {
        transactionService.status().then((result) => {
            result = result.filter(x => x.value !== StatusEnum.Chargeback.toString());
            const statusTemp = result.map((item) => {
                item.label = i18n.language.includes("es") 
                    ? statusJson[item.value]?.textEs 
                    : statusJson[item.value]?.textEn;
                return item;
            });
            setStatus(statusTemp);
            getTransactions(cursorStack[cursorStack.length - 1] || 0, cursorStack);
        });
    }, [i18n.language]);

    const getTransactions = (lastId, stack) => {
        const activeStack = stack || cursorStack;
        sessionStorage.setItem("rp_CursorStack", JSON.stringify(activeStack));
        if (filters.idStatus == StatusEnum.ProcessOfAppeal && filters.statusChargeBack.length == 0) {
            setTableData({ rows: 0, hasMore: false });
            setData([]);
        } else {
            filters.initDate =
                filters.initDate == "Invalid Date" ? "" : filters.initDate;
            filters.endDate = filters.endDate == "Invalid Date" ? "" : filters.endDate;

            transactionService
                .get({ ...filters, lastId: lastId || 0, rowsOfPage: pageSize })
                .then((result) => {
                    localStorage.setItem("statusIdTransaction", filters.idStatus);
                    setData(result);
                    if (result.length > 0) {
                        const seen = (activeStack.length - 1) * pageSize + result.length;
                        setTableData({
                            rows: result[0].maxRows,
                            hasMore: seen < result[0].maxRows,
                        });
                        setIsChargeBack(filters.idStatus == StatusEnum.ProcessOfAppeal);
                        sessionStorage.setItem("rp_filters", JSON.stringify(filters));
                    }
                    else setTableData({ rows: 0, hasMore: false });
                });
        }
    };

    const handleFilters = () => {
        const stack = [0];
        persistStack(stack);
        sessionStorage.setItem("rp_filters", JSON.stringify(filters));
        getTransactions(0, stack);
    };

    const handleNext = () => {
        if (!data.length || !tableData.hasMore) return;
        const stack = [...cursorStack, data[data.length - 1].idTransaction];
        persistStack(stack);
        getTransactions(data[data.length - 1].idTransaction, stack);
    };

    const handlePrev = () => {
        if (cursorStack.length <= 1) return;
        const stack = cursorStack.slice(0, -1);
        persistStack(stack);
        getTransactions(stack[stack.length - 1] || 0, stack);
    };

    const columns = getColumns(userSetting, handleFilters,null, t, i18n);

    const generateReport = () => {
        if (tableData.rows > 0) {
            const translations = t('reports.transactions', { returnObjects: true });
            transactionService.generateReport({ ...filters, rows: tableData.rows, translations });
        }
    };

    const initCalendar = (filtersx) => {
        let fechaFinal = undefined;
        let fechaInicial = undefined;
        if (filtersx.endDate != "" || filtersx.endDate != "Invalid Date") { fechaFinal = filtersx.endDate } else { fechaFinal = currentDate; }
        if (filtersx.initDate == "" || filtersx.initDate != "Invalid Date") { fechaInicial = filtersx.initDate } else { fechaInicial = currentDate; }
        return (<CalendarRange
            defaultValue={fechaInicial && fechaFinal ? [fechaInicial, fechaFinal] : []}
            onChange={(value) => {
                var filterSession;
                if (sessionStorage["rp_filters"]) {
                    filterSession = JSON.parse(sessionStorage["rp_filters"]);
                } else {
                    filterSession = filters;
                }

                filterSession.initDate = value[0];
                filterSession.endDate = value[1];
                sessionStorage.setItem("rp_filters", JSON.stringify(filterSession));
                return setFilters({
                    ...filters,
                    initDate: value[0],
                    endDate: value[1],
                })
            }
            }
        />);
    }

    const showFilterMoney = () => {
        return <FlexboxGrid>
            <FlexboxGrid.Item className="mb-6"
                              componentClass={Col}
                              md={6}
                              sm={12}
                              xs={24}
                              style={{ fontSize: 11 }}>
                <FormGroup>
                    <InputGroup inside>
                        <Checkbox key="chkMoney" checked={filters.isMoney}
                                  disabled={!statusMoney.includes(parseInt(filters.idStatus == null ? 0 : filters.idStatus))}
                                  onChange={(value) => {
                                      let newFilters = { ...filters };
                                      if (newFilters.isMoney) { newFilters.referenceCash = ""; }
                                      newFilters.isMoney = !newFilters.isMoney;
                                      setFilters(newFilters);
                                  }}>{t('transactions.searchCashReference')}</Checkbox>
                    </InputGroup>
                </FormGroup>
            </FlexboxGrid.Item>
            {filters.isMoney && statusMoney.includes(parseInt(filters.idStatus == null ? 0 : filters.idStatus)) &&
                <FlexboxGrid.Item className="mb-6"
                                  componentClass={Col}
                                  md={6}
                                  sm={12}
                                  xs={24}
                                  style={{ fontSize: 11 }}>
                    <FormGroup>
                        <ControlLabel>{t('transactions.searchCashReference')}</ControlLabel>
                        <InputGroup inside>
                            <FormControl
                                size="lg"
                                name="input-1"
                                placeholder={t('transactions.ticketReference')}
                                onChange={(value) =>
                                    setFilters({ ...filters, referenceCash: value })
                                }
                                value={filters.referenceCash}
                            />
                            <InputGroup.Addon>
                                <Icon icon="search" />
                            </InputGroup.Addon>
                        </InputGroup>
                    </FormGroup>
                </FlexboxGrid.Item>}
        </FlexboxGrid>;
    }

    return (
        <section className="wrapper_transactions">
            <TitleSection title={t('transactions.movements')} />
            <div className="text-right">
                <Button
                    className="btn c_primary"
                    appearance="subtle"
                    type="submit"
                    onClick={generateReport}
                >
                    <Icon icon="file" />
                    <span className="fw-400"> {t('transactions.generateReport')}</span>
                </Button>
            </div>
            <div className="box_filter_options">
                <Form onSubmit={handleFilters}>
                    <FlexboxGrid align="bottom">
                        <FlexboxGrid.Item
                            className="mb-3"
                            componentClass={Col}
                            md={6}
                            sm={12}
                            xs={24}
                        >
                            <FormGroup>
                                <ControlLabel>{t('transactions.searchByDateRange')}</ControlLabel>
                                {initCalendar(filters)}
                            </FormGroup>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item
                            className="mb-3"
                            componentClass={Col}
                            md={5}
                            sm={12}
                            xs={24}
                        >
                            <FormGroup>
                                <ControlLabel>{t('transactions.searchByStatus')}</ControlLabel>
                                <SelectPicker
                                    block
                                    size="lg"
                                    placeholder={t('transactions.select')}
                                    data={status.filter(item => item.label && item.value)}
                                    onChange={(value) => {
                                        let newFilters = { ...filters };
                                        newFilters.idStatus = value;
                                        if (!statusMoney.includes(parseInt(value))) {
                                            newFilters.referenceCash = "";
                                            newFilters.isMoney = false;
                                        }
                                        setFilters(newFilters);
                                        setIsChargeBack(value == StatusEnum.ProcessOfAppeal);
                                    }}
                                    value={filters.idStatus}
                                />
                            </FormGroup>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item
                            className="mb-3"
                            componentClass={Col}
                            md={5}
                            sm={12}
                            xs={24}
                        >
                            <FormGroup>
                                <ControlLabel>{t('transactions.searchByReference')}</ControlLabel>
                                <InputGroup inside>
                                    <FormControl
                                        size="lg"
                                        name="input-1"
                                        placeholder={t('transactions.reference')}
                                        onChange={(value) =>
                                            setFilters({ ...filters, referenceNumber: value })
                                        }
                                        value={filters.referenceNumber}
                                    />
                                    <InputGroup.Addon>
                                        <Icon icon="search" />
                                    </InputGroup.Addon>
                                </InputGroup>
                            </FormGroup>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item
                            className="mb-3"
                            componentClass={Col}
                            md={5}
                            sm={12}
                            xs={24}
                        >
                            <FormGroup>
                                <ControlLabel>{t('transactions.searchByEmail')}</ControlLabel>
                                <InputGroup inside>
                                    <FormControl
                                        size="lg"
                                        name="input-1"
                                        placeholder={t('transactions.email')}
                                        onChange={(value) =>
                                            setFilters({ ...filters, email: value })
                                        }
                                        value={filters.email}
                                    />
                                    <InputGroup.Addon>
                                        <Icon icon="search" />
                                    </InputGroup.Addon>
                                </InputGroup>
                            </FormGroup>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item
                            className="mb-3"
                            componentClass={Col}
                            md={3}
                            sm={12}
                            xs={24}
                        >
                            <Button
                                className="btn secundary"
                                size="lg"
                                block
                                appearance="primary"
                                type="submit"
                            >
                                {t('transactions.search')}
                            </Button>
                        </FlexboxGrid.Item>
                    </FlexboxGrid>
                    {showFilterMoney()}
                    {isChargeBack ? (
                        <FlexboxGrid>
                            <FlexboxGrid.Item className="mb-5"
                                              componentClass={Col}
                                              md={5}
                                              sm={12}
                                              xs={24}
                                              style={{ fontSize: 11 }}>
                                <CheckboxGroup inline name="chkStatusChargeback" value={filters.statusChargeBack} onChange={(value) => { setFilters({ ...filters, statusChargeBack: value }); }}>
                                    {statusChargeBack ? (statusChargeBack.map(item => {
                                        return <Checkbox key={`chk${item.idStatusChargeBack}`} value={item.idStatusChargeBack}>{item.description}</Checkbox>
                                    })) : ''}
                                </CheckboxGroup>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>) : ''}
                </Form>
            </div>

            <div className="mt-3 mb-5">
                <br />
                <Table myData={data} myColumns={columns}></Table>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 16 }}>
                    <Button appearance="ghost" disabled={cursorStack.length <= 1} onClick={handlePrev}>
                        {t('transactions.previous')}
                    </Button>
                    <span>{tableData.rows} {t('transactions.movements').toLowerCase()}</span>
                    <Button appearance="ghost" disabled={!tableData.hasMore} onClick={handleNext}>
                        {t('transactions.next')}
                    </Button>
                </div>
            </div>
        </section>
    );
};